export const iconFontAwesomeGendersMarsStrokeRight = (
	<i className="fa-solid fa-mars-stroke-right"></i>
);
